import { fg } from '@confluence/feature-gating';
import { isFedRamp } from '@atlassian/atl-context';
import { useSessionDataWithRovoExperiment } from '@confluence/session-data';

export const useAIRovoButtonEnablement = () => {
	const { isAdminHubAIEnabled, isRovoEnabled, isRovoLLMEnabled } =
		useSessionDataWithRovoExperiment();
	const shouldShowRovo = fg('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;

	return !isFedRamp() && isAdminHubAIEnabled && shouldShowRovo && fg('ai-smart-button-team-25');
};
